<template>
	<t-horizontal-panel style="overflow: hidden;">
		<deviationSearchFilters slot="left" />
		<deviationList style="flex:1;" />
	</t-horizontal-panel>
</template>

<script>
import { tryRegisterStoreDynamically } from './store/deviationSearch.store.js';

import DeviationSearchFilters from './DeviationSearchFilters';
import DeviationList from './DeviationList';

export default {
	name: 'DeviationSearch',
	components: {
		DeviationSearchFilters,
		DeviationList,
	},

	computed: {
		searchId() {
			return this.$route.params.searchId || -1;
		},
		computedStoreNamespace() {
			return `deviationSearch/${this.searchId}`;
		}
	},

	beforeRouteEnter(to, from, next) {
		let id = to.params.searchId || -1;
		tryRegisterStoreDynamically(id);
		next();
	},
	beforeRouteUpdate(to, from, next) {
		let id = to.params.searchId || -1;
		tryRegisterStoreDynamically(id);
		next();
	}
};
</script>

<style lang="scss" scoped>

</style>
